import { LabelsRhdoc } from '../sew-ws-header/types/labels.types';
import { BlogPostResponse, FooterData } from './sew-ws-footer-api.types';

export async function fetchFooterData(
    language: string,
    caasBaseUrl: string,
    cmsCountryId: string
): Promise<FooterData | null> {
    const url = new URL(`${caasBaseUrl}/direct/SEW${cmsCountryId.toUpperCase()}/main-footer`);

    url.searchParams.append('filter', `{'fs_language':'${language}'}`);

    return await fetch(url.href)
        .then(res => res.json())
        .then(
            data => {
                if (typeof data._embedded !== 'undefined') {
                    return data._embedded['rh:doc'][0];
                }

                return null;
            },
            err => console.error(err)
        )
        .catch(err => console.error(err));
}

export async function fetchNewestBlogPostData(
    language: string,
    caasBaseUrl: string,
    cmsCountryId: string
): Promise<BlogPostResponse | null> {
    const url = new URL(`${caasBaseUrl}/direct/Blog-${cmsCountryId.toUpperCase()}/blog_posts`);
    const date = new Date();
    date.setMinutes(0);
    date.setSeconds(0);

    url.searchParams.append('filter', `{'fs_language':'${language}'}`);
    url.searchParams.append(
        'filter',
        `{'date': {'$lt': '${date.toISOString().replace('T', ' ').substring(0, 19)}'}}`
    );
    url.searchParams.append('page', '1');
    url.searchParams.append('pagesize', '1');
    url.searchParams.append('sort', '-date');

    return await fetch(url.href)
        .then(res => res.json())
        .then(
            data => {
                if (typeof data._embedded !== 'undefined') {
                    return data._embedded['rh:doc'][0];
                }

                return null;
            },
            err => console.error(err)
        )
        .catch(err => console.error(err));
}

export async function fetchLabels(
    language: string,
    caasBaseUrl: string,
    cmsCountryId: string
): Promise<LabelsRhdoc | null> {
    const url = new URL(`${caasBaseUrl}/direct/SEW${cmsCountryId.toUpperCase()}/dictionary`);

    url.searchParams.append('filter', `{'fs_language':'${language}'}`);
    url.searchParams.append('keys', '{"dictionary.CMS_FOOTER_READ_BLOG_POST":1}');

    return await fetch(url.href)
        .then(res => res.json())
        .then(
            data => {
                if (typeof data._embedded !== 'undefined') {
                    return data._embedded['rh:doc'][0];
                }

                return null;
            },
            err => console.error(err)
        )
        .catch(err => console.error(err));
}
